import { useState, useEffect } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase'; // Adjust path as needed

export const useUserSettings = (userId) => {
  const [settings, setSettings] = useState({
    notifications: {
      email: true,
      push: true
    },
    theme: 'light',
    loading: true,
    error: null
  });

  // Fetch settings on mount
  useEffect(() => {
    const fetchSettings = async () => {
      if (!userId) return;

      try {
        const userDoc = await getDoc(doc(db, 'pilot', userId));
        if (userDoc.exists() && userDoc.data().settings) {
          setSettings(prevSettings => ({
            ...prevSettings,
            ...userDoc.data().settings,
            loading: false
          }));
        } else {
          // If no settings exist, initialize them
          await updateDoc(doc(db, 'pilot', userId), {
            settings: {
              notifications: {
                email: true,
                push: true
              },
              theme: 'light'
            }
          });
          setSettings(prevSettings => ({
            ...prevSettings,
            loading: false
          }));
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
        setSettings(prevSettings => ({
          ...prevSettings,
          error: 'Failed to load settings',
          loading: false
        }));
      }
    };

    fetchSettings();
  }, [userId]);

  // Update settings in Firebase
  const updateSettings = async (newSettings) => {
    if (!userId) return;

    try {
      setSettings(prevSettings => ({
        ...prevSettings,
        loading: true,
        error: null
      }));

      await updateDoc(doc(db, 'pilot', userId), {
        settings: {
          notifications: newSettings.notifications,
          theme: newSettings.theme
        }
      });

      setSettings(prevSettings => ({
        ...prevSettings,
        ...newSettings,
        loading: false
      }));

      return true;
    } catch (error) {
      console.error('Error updating settings:', error);
      setSettings(prevSettings => ({
        ...prevSettings,
        error: 'Failed to save settings',
        loading: false
      }));
      return false;
    }
  };

  return {
    settings: {
      notifications: settings.notifications,
      theme: settings.theme
    },
    loading: settings.loading,
    error: settings.error,
    updateSettings
  };
};